import clearGlass from './clear-glass.jpg';
import obscureGlass from './obscure-glass.jpg';
import verticalGlass from './vertical-bars.jpg';

export default {
  Clear: clearGlass,
  Obscure: obscureGlass,
  'Vertical Bars': verticalGlass,
};
